import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, TwitterAuthProvider,OAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider, AppCheck } from 'firebase/app-check'; // Import App Check

const firebaseConfig = {
  apiKey: import.meta.env.VITE_REACT_APP_API_KEY,
  authDomain: import.meta.env.VITE_REACT_APP_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_REACT_APP_PROJECT_ID,
  storageBucket: import.meta.env.VITE_REACT_APP_STORAGE_BUCKET,
  messagingSenderId:import.meta.env.VITE_REACT_APP_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_REACT_APP_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check
let appCheck: AppCheck | undefined;
// Make sure VITE_RECAPTCHA_SITE_KEY is set in your .env file
if (import.meta.env.VITE_RECAPTCHA_SITE_KEY) {
  try {
    // In development, you might want to use debug tokens
    const isDevelopment = import.meta.env.DEV;
    
    if (isDevelopment) {
      // Use the specific debug token from Firebase Console
      (window as any).self = window;
            (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = "B7AFA6F4-F3F7-4786-9FBB-EEEC3A51ED18";
      console.log("🔧 Development mode: Using registered debug token");
            console.log("✅ Debug token: B7AFA6F4-F3F7-4786-9FBB-EEEC3A51ED18");
    }
    
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    });
    console.log("✅ Firebase App Check initialized successfully");
  } catch (error) {
    console.error("❌ Failed to initialize Firebase App Check:", error);
    if (import.meta.env.DEV) {
      console.warn("⚠️  Development mode: App Check errors may cause Firebase operations to fail");
      console.log("🔧 Quick fixes:");
      console.log("   1. Disable App Check enforcement in Firebase Console (temporary)");
      console.log("   2. Add debug tokens in Firebase Console (recommended)");
      console.log("   3. Check if reCAPTCHA site key is correct");
    }
  }
} else {
    console.warn("⚠️  Firebase App Check: VITE_RECAPTCHA_SITE_KEY is not set. App Check is not initialized.");
    if (import.meta.env.DEV) {
      console.log("🔧 Add VITE_RECAPTCHA_SITE_KEY to your .env file to enable App Check");
    }
}


const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const twitterProvider = new TwitterAuthProvider();
const microsoftProvider= new OAuthProvider('microsoft.com');
const db = getFirestore(app);

// Export 'app' for use in other files like services.tsx
export { app, auth, googleProvider, facebookProvider, twitterProvider, microsoftProvider, db, appCheck };
